export default {
    bookDir: 'book',
}
